module.exports = __webpack_public_path__ + "img/7.281fe3d6.png";